import { _axios } from "../../Utils/Axios/axios";

export const sendPdfRequestForFullQuizService = async (
  userToken: string,
  quizId: string | Number,
  userQuestions: string[]
) => {
  return _axios.post(
    "/request/pdf",
    {
      q: userQuestions.toString(),
      lesson_id: null,
      subject_id: null,
      quiz_id: String(quizId),
    },
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
